// 特典センター（右下FAB＋モーダル）の制御。
// カート内の「対象商品の個数」を基準に、各施策ブロック（追加購入・プレゼント）の解錠と
// FABの赤丸バッジ・アニメーションを更新する。設定は window.PerkConfig 経由。
//
// 数え方は施策ごとに独立している。各ブロックの data-target-ids に対象商品IDを持ち、
// 空ならカート内の全商品を数える。「特定商品を1個入れたらプレゼント」も
// 「対象商品を3個買ったら解錠」も、この1つの仕組みで表現できる。
(() => {
  const fab = document.querySelector("[data-perk-fab]");
  const overlay = document.querySelector("[data-perk-overlay]");
  if (!fab || !overlay) return;

  // 右下のFABが他セクションのものと並ぶ場合、fab-rotator.js が交互に見せる。
  // その対象単位はラッパー要素なので、ここで掴んでおく。
  const wrap = fab.closest("[data-fab-slot]") || fab;

  const config = window.PerkConfig || {};

  const countEl = fab.querySelector("[data-perk-count]");
  const addonBlocks = overlay.querySelectorAll("[data-perk-addon-block]");
  const giftBlocks = overlay.querySelectorAll("[data-perk-gift-block]");
  const fsbBlock = overlay.querySelector("[data-perk-fsb-block]");
  const fsbThreshold = fsbBlock ? parseInt(fsbBlock.getAttribute("data-threshold"), 10) || 0 : 0;
  const fsbTemplate = fsbBlock ? fsbBlock.getAttribute("data-remaining-template") || "あと[金額]" : "";

  const selectedAddons = {}; // { variantId: qty }
  let cartItems = [];
  // 直前のカート内容。「今回何が増えたか」を知るために保持する。
  let lastCartQty = new Map();
  let addedProductIds = new Set();
  // 自動オープンの判定に使う「お客様が今回入れた商品」。プレゼント付与の影響を受けない。
  let pendingAdded = new Set();
  // ブロック要素 → 対象商品IDのSet（null なら全商品が対象）
  const targetSets = new Map();

  // 商品ページのスティッキーな「カートに追加」バーが出ている間は、
  // FABがバーと重ならないよう一段持ち上げる（バーの実高さで自動調整）。
  const stickyBar = document.querySelector(".sticky-add-to-cart");
  if (stickyBar) {
    const syncFabOffset = () => {
      if (stickyBar.classList.contains("is-visible")) {
        fab.style.bottom = stickyBar.offsetHeight + 16 + "px";
      } else {
        fab.style.bottom = "";
      }
    };
    new MutationObserver(syncFabOffset).observe(stickyBar, {
      attributes: true,
      attributeFilter: ["class"],
    });
    window.addEventListener("resize", syncFabOffset);
    syncFabOffset();
  }

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  // ブロックの対象商品IDを一度だけ解釈して覚えておく。
  // null を返すと「全商品が対象」。空のSetを返すと「対象なし（解錠しない）」。
  // 「空欄にした」と「指定したが解決できなかった」を取り違えると、
  // 条件を満たしていないのに解錠されてしまうため、モードで明示的に分ける。
  function targetSetOf(block) {
    if (targetSets.has(block)) return targetSets.get(block);
    const mode = block.getAttribute("data-target-mode") || "all";
    let set;
    if (mode === "all") {
      set = null;
    } else {
      const raw = (block.getAttribute("data-target-ids") || "").trim();
      set = new Set(raw ? raw.split(",").map((id) => parseInt(id, 10)) : []);
    }
    targetSets.set(block, set);
    return set;
  }

  // そのブロックにとっての「カート内の対象個数」
  function countFor(block) {
    const targets = targetSetOf(block);
    return cartItems.reduce((sum, item) => {
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "badge" || itemType === "gift") return sum;
      if (targets && !targets.has(item.product_id)) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function giftDesiredQty(count, threshold, mode) {
    if (count < threshold) return 0;
    return mode === "multiply" ? Math.floor(count / threshold) : 1;
  }

  // クエストカード（進捗バー・カウント・達成状態の色）を更新し、
  // アンロック済みかどうかを返す
  function updateQuestUI(block, threshold) {
    const count = countFor(block);
    const unlocked = count >= threshold;
    const quest = block.querySelector(".perk-quest");
    if (!quest) return unlocked;

    quest.classList.toggle("perk-quest--unlocked", unlocked);

    const fill = quest.querySelector("[data-perk-quest-fill]");
    if (fill) {
      fill.style.width = Math.min(100, Math.round((count / threshold) * 100)) + "%";
    }
    const questCount = quest.querySelector("[data-perk-quest-count]");
    if (questCount) {
      questCount.textContent = Math.min(count, threshold) + " / " + threshold;
    }
    return unlocked;
  }

  // 送料無料カード（金額ベース）の進捗バー・達成状態を更新し、達成済みかどうかを返す
  function updateFreeShippingUI(totalPriceCents) {
    if (!fsbBlock || fsbThreshold <= 0) return false;
    const quest = fsbBlock.querySelector("[data-perk-fsb-quest]");
    const achieved = totalPriceCents >= fsbThreshold;
    if (quest) quest.classList.toggle("perk-quest--unlocked", achieved);

    const fill = fsbBlock.querySelector("[data-perk-fsb-fill]");
    if (fill) {
      fill.style.width = Math.min(100, Math.round((totalPriceCents / fsbThreshold) * 100)) + "%";
    }
    const countEl = fsbBlock.querySelector("[data-perk-fsb-count]");
    if (countEl) {
      const remainingYen = Math.max(0, Math.ceil((fsbThreshold - totalPriceCents) / 100));
      countEl.textContent = achieved ? "" : fsbTemplate.replace("[金額]", "¥" + remainingYen.toLocaleString());
    }
    return achieved;
  }

  function updateFromItems(items, totalPrice) {
    cartItems = items;

    const nextQty = new Map();
    items.forEach((item) => {
      nextQty.set(item.product_id, (nextQty.get(item.product_id) || 0) + item.quantity);
    });
    addedProductIds = new Set();
    nextQty.forEach((qty, productId) => {
      if (qty > (lastCartQty.get(productId) || 0)) addedProductIds.add(productId);
    });
    lastCartQty = nextQty;

    let activatedCount = 0;

    addonBlocks.forEach((block) => {
      const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 1;
      const unlocked = updateQuestUI(block, threshold);

      block.classList.toggle("perk-block--locked", !unlocked);
      block.querySelectorAll("[data-perk-minus], [data-perk-plus]").forEach((btn) => {
        const row = btn.closest("[data-perk-badge-row]");
        const soldout = row && row.classList.contains("perk-badge-row--soldout");
        btn.disabled = !unlocked || soldout;
      });
      if (!unlocked) resetAddonSelection(block);
      updateAddonAddButton(block);
      if (unlocked) activatedCount++;
    });

    giftBlocks.forEach((block) => {
      const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 6;
      const mode = block.getAttribute("data-mode") === "multiply" ? "multiply" : "single";
      const unlocked = updateQuestUI(block, threshold);
      const desired = giftDesiredQty(countFor(block), threshold, mode);

      block.classList.toggle("perk-gift--locked", !unlocked);
      const qtyEl = block.querySelector("[data-perk-gift-qty]");
      if (qtyEl) qtyEl.textContent = desired;
      syncGiftVariantChoice(block);
      if (unlocked) activatedCount++;
    });

    if (updateFreeShippingUI(totalPrice || 0)) activatedCount++;

    if (countEl) {
      countEl.hidden = activatedCount < 1;
      countEl.textContent = activatedCount;
    }
    fab.classList.toggle("gift-fab--idle", activatedCount < 1);

    // 特典が1つも有効でないならFABごと出さない（おすすめセンターと挙動を揃える）
    const shouldShow = activatedCount > 0 || config.alwaysShow === true;
    if (wrap.hidden !== !shouldShow) {
      wrap.hidden = !shouldShow;
      if (window.FabRotator) window.FabRotator.refresh();
    }

    unlockedNow = activatedCount > 0;
  }

  // 今回増えた商品が、いずれかの施策の対象に当てはまるか
  function triggeredByAddition(added) {
    return blocksWithTarget().some((block) => {
      const targets = targetSetOf(block);
      if (!targets) return added.size > 0;
      for (const productId of added) {
        if (targets.has(productId)) return true;
      }
      return false;
    });
  }

  function blocksWithTarget() {
    return [].concat(Array.from(addonBlocks), Array.from(giftBlocks));
  }

  // 対象商品が「今回」増えて条件を満たしたときだけ開く。
  // カートに居続けるかぎり毎回開く、という挙動にはしない。
  function handleAddedFeedback() {
    flashBubble();

    // 判定に使ったら捨てる。持ち越すと、後から来た別のカート更新で
    // 同じ追加をもう一度きっかけとして扱ってしまう。
    const added = pendingAdded;
    pendingAdded = new Set();

    if (config.openBehavior !== "auto") return;
    if (wrap.hidden || !unlockedNow) return;
    if (!triggeredByAddition(added)) return;

    // おすすめセンターと同時に成立した場合、どちらを開くかは設定に従う
    if (config.autoOpenPriority !== "perk" && Date.now() < (window.__recommendAutoOpenUntil || 0)) return;

    const delay = Number(config.autoOpenDelay) || 0;
    window.__perkAutoOpenUntil = Date.now() + delay + 800;
    setTimeout(open, delay);
  }

  function refresh() {
    return fetch(getRootUrl() + "cart.js", { cache: "no-store" })
      .then((res) => res.json())
      .then((cart) => {
        updateFromItems(cart.items, cart.total_price);
        // プレゼントを付与すると差分が取り直され、お客様が入れた商品が
        // 「今回増えたもの」から消えてしまう。判定用にここで退避しておく。
        // 増えた商品が無いときに上書きすると、直前の追加が消えて自動オープンの
        // きっかけを失う（プレゼント付与に続く再取得で起きる）。
        if (addedProductIds.size > 0) pendingAdded = new Set(addedProductIds);
        // 付与と特典コードの適用は裏で進める。ここで待つと、通信が重なったときに
        // 自動オープンの判定が数秒遅れ、その間に別の更新へ追い越される。
        syncGifts(cart.items).then(() => syncDiscountState(cart));
      })
      .catch(() => {});
  }

  /* -------------------------------------------------
   * プレゼントの自動付与
   *
   * カートページでは cart-gift-sync.js が同じ役割（＋確認ダイアログや連動削除）を
   * 担うため、ここでは手を出さない。二重に補正すると打ち消し合う。
   * それ以外のページでは付与処理が存在しなかったため、対象商品を入れても
   * カートページを開くまでプレゼントが付かなかった。
   * ------------------------------------------------- */
  const perkGifts = Array.isArray(config.gifts) ? config.gifts : [];
  const giftTargets = new Map();
  let giftSyncInFlight = false;
  let unlockedNow = false;

  const isCartPage = () => document.querySelector("cart-items") !== null;

  // モーダル側の targetSetOf と同じ規則（null=全商品 / 空Set=対象なし）
  function giftTargetSetOf(gift) {
    if (giftTargets.has(gift)) return giftTargets.get(gift);
    const ids = Array.isArray(gift.targetIds) ? gift.targetIds : [];
    const set = gift.targetMode === "all" ? null : new Set(ids.map(Number));
    giftTargets.set(gift, set);
    return set;
  }

  function giftCountFor(gift, items) {
    const targets = giftTargetSetOf(gift);
    return items.reduce((sum, item) => {
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "badge" || itemType === "gift") return sum;
      if (targets && !targets.has(item.product_id)) return sum;
      return sum + item.quantity;
    }, 0);
  }

  // いま必要な補正内容を洗い出す。お客様が選んだバリエーションは尊重する。
  function planGiftOps(items) {
    const giftLines = {};
    items.forEach((item) => {
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "gift") giftLines[String(item.variant_id)] = item;
    });

    const ops = [];
    const handled = new Set();

    perkGifts.forEach((gift) => {
      const variantIds = (Array.isArray(gift.variantIds) ? gift.variantIds : []).map(String);
      if (variantIds.length === 0) return;

      const count = giftCountFor(gift, items);
      const threshold = parseInt(gift.threshold, 10) || 1;
      const mode = gift.mode === "multiply" ? "multiply" : "single";
      const desired = count >= threshold ? (mode === "multiply" ? Math.floor(count / threshold) : 1) : 0;

      const chosen = variantIds.find((id) => giftLines[id]);
      const targetVariant = chosen || variantIds[0];
      variantIds.forEach((id) => handled.add(id));

      const line = giftLines[targetVariant] || null;
      const current = line ? line.quantity : 0;
      if (desired !== current) ops.push({ line: line, variantId: targetVariant, desired: desired });

      // 同じ施策で複数のバリエーションが入っていたら、選ばれた1つだけ残す
      variantIds.forEach((id) => {
        if (id !== targetVariant && giftLines[id]) {
          ops.push({ line: giftLines[id], variantId: id, desired: 0 });
        }
      });
    });

    // 設定から外れたプレゼント行は引き上げる
    Object.keys(giftLines).forEach((variantId) => {
      if (!handled.has(variantId)) {
        ops.push({ line: giftLines[variantId], variantId: variantId, desired: 0 });
      }
    });

    return ops;
  }

  // いまカートに入っているバリエーションを、選択状態としてチップに反映する。
  // 何も入っていなければ先頭を選択済みに見せる（付与されるのがそれのため）。
  function syncGiftVariantChoice(block) {
    const chips = block.querySelectorAll("[data-perk-gift-variant]");
    if (chips.length === 0) return;

    const inCart = new Set();
    cartItems.forEach((item) => {
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "gift") inCart.add(String(item.variant_id));
    });

    let selected = null;
    chips.forEach((chip) => {
      const id = chip.getAttribute("data-perk-gift-variant");
      if (!selected && inCart.has(id)) selected = id;
    });
    if (!selected) selected = chips[0].getAttribute("data-perk-gift-variant");

    chips.forEach((chip) => {
      const isSelected = chip.getAttribute("data-perk-gift-variant") === selected;
      chip.classList.toggle("is-selected", isSelected);
      chip.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  }

  // プレゼントのバリエーションを差し替える。
  // 先に古い行を外してから入れる。逆順だと、同じ施策で2つ入った状態を
  // syncGifts が「片方を削除」と解釈し、選んだほうが消えることがある。
  function changeGiftVariant(block, nextVariantId) {
    if (giftSyncInFlight) return;
    const ids = (block.getAttribute("data-gift-variant-ids") || "").split(",").filter(Boolean);
    if (ids.indexOf(nextVariantId) === -1) return;

    const lines = {};
    cartItems.forEach((item) => {
      const itemType = item.properties ? item.properties["_item_type"] : null;
      if (itemType === "gift") lines[String(item.variant_id)] = item;
    });

    const currentId = ids.find((id) => lines[id]);
    if (currentId === nextVariantId) return;

    const quantity = currentId ? lines[currentId].quantity : 1;
    giftSyncInFlight = true;
    window.__perkGiftSyncUntil = Date.now() + 5000;

    const steps = [];
    if (currentId) steps.push({ line: lines[currentId], variantId: currentId, desired: 0 });
    steps.push({ line: null, variantId: nextVariantId, desired: quantity });

    steps
      .reduce((chain, op) => chain.then(() => applyGiftOp(op)), Promise.resolve())
      .then(() => fetch(getRootUrl() + "cart.js", { cache: "no-store" }))
      .then((res) => res.json())
      .then((cart) => {
        updateFromItems(cart.items, cart.total_price);
        return syncDiscountState(cart);
      })
      .then(refreshCartUi)
      .catch(() => {})
      .then(() => {
        giftSyncInFlight = false;
      });
  }

  // カートを書き換えたあと、画面側も追従させる。
  // これが無いと、カートの中身は変わっているのに表示だけ古いままになる。
  function refreshCartUi() {
    // カートページは行そのものを描き直す必要があるため、素直に読み込み直す
    if (isCartPage()) {
      window.location.reload();
      return Promise.resolve();
    }
    // それ以外のページはヘッダーのカート表示だけ追従させる
    return fetch(getRootUrl() + "?sections=cart-icon-bubble", { cache: "no-store" })
      .then((res) => res.json())
      .then((sections) => {
        const html = sections && sections["cart-icon-bubble"];
        const target = document.getElementById("cart-icon-bubble");
        if (!html || !target) return;
        const parsed = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
        if (parsed) target.innerHTML = parsed.innerHTML;
      })
      .catch(() => {});
  }

  /* -------------------------------------------------
   * 特典コード（割引コード）
   *
   * プレゼントが自動でカートへ入ったタイミングで、テーマエディタに設定された
   * コードを裏で適用する。お客様には入力欄も適用の知らせも出さない。
   *
   * 適用は /cart/update.js の discount パラメータで行う（Shopifyが公式に対応している方法）。
   * 旧来の /discount/<コード> はチェックアウトでは効くのにカートの表示へ反映されないことがある。
   * ------------------------------------------------- */
  const discountConfig = config.discount || {};
  // 適用は1つのカートにつき1回だけ。読み込み直しをまたいでも繰り返さないようにする。
  // （お客様がチェックアウトで自分で外した場合に、勝手に戻さないためでもある）
  const AUTO_DISCOUNT_KEY = "perk-auto-discount";
  let discountInFlight = false;

  const normalizeCode = (code) => String(code || "").trim().toLowerCase();

  // いまカートに効いている割引の名前。コード割引は名前がコードそのものになる。
  function appliedDiscountNames(cart) {
    const names = new Set();
    ((cart && cart.cart_level_discount_applications) || []).forEach((app) => {
      if (app && app.title) names.add(normalizeCode(app.title));
    });
    ((cart && cart.items) || []).forEach((item) => {
      ((item && item.discounts) || []).forEach((d) => {
        if (d && d.title) names.add(normalizeCode(d.title));
      });
    });
    return names;
  }

  // "ok" = 割引が出ている / "pending" = 受理されたがまだ効いていない / "error" = 使えなかった
  function inspectDiscount(cart, code) {
    const needle = normalizeCode(code);
    if (!needle) return "error";
    // discount_codes はAjax APIの公式ドキュメントには無いが実際には返ることがある。
    // あれば「受理されたかどうか」の最も確かな手がかりになるので優先して見る。
    const codes = cart && cart.discount_codes;
    if (Array.isArray(codes)) {
      const hit = codes.filter((d) => normalizeCode(d && d.code) === needle)[0];
      if (!hit || hit.applicable === false) return "error";
    }
    return appliedDiscountNames(cart).has(needle) ? "ok" : "pending";
  }

  // プレゼントはラインアイテムプロパティで見分ける（自動付与時に付けている印）
  function cartHasGift(cart) {
    return ((cart && cart.items) || []).some(
      (item) => item.properties && item.properties["_item_type"] === "gift"
    );
  }

  function sendDiscount(code) {
    return fetch(getRootUrl() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: code }),
    }).then((res) => (res.ok ? res.json() : Promise.reject(res)));
  }

  function markDiscountDone(cart) {
    try {
      sessionStorage.setItem(AUTO_DISCOUNT_KEY, (cart && cart.token) || "1");
    } catch (e) {
      /* プライベートブラウズ等で保存できなくても機能自体は続行する */
    }
  }

  function discountAlreadyDone(cart) {
    try {
      return sessionStorage.getItem(AUTO_DISCOUNT_KEY) === ((cart && cart.token) || "1");
    } catch (e) {
      return false;
    }
  }

  function applyDiscount(code) {
    discountInFlight = true;
    return sendDiscount(code)
      .then((cart) => {
        const state = inspectDiscount(cart, code);
        if (state === "ok") {
          // 割引が実際に出たときだけ画面を描き直す
          return refreshCartUi();
        }
        // 効かなかった場合、お客様には何も見せない（操作していないため知らせようがない）。
        // 設定ミスに運営側が気づけるよう記録だけ残す。
        if (state === "error") {
          console.warn("[特典センター] 特典コードが適用されませんでした:", code);
        }
        return null;
      })
      .catch(() => {})
      .then(() => {
        discountInFlight = false;
      });
  }

  // カートを読み直すたびに呼ばれる。プレゼントが入っていれば特典コードを当てる。
  function syncDiscountState(cart) {
    const code = String(discountConfig.code || "").trim();
    if (!cart || !code) return Promise.resolve();

    if (inspectDiscount(cart, code) === "ok") {
      markDiscountDone(cart);
      return Promise.resolve();
    }
    if (discountInFlight || discountAlreadyDone(cart)) return Promise.resolve();
    // プレゼントが入る前に当てても意味がないので、入ってから適用する
    if (!cartHasGift(cart)) return Promise.resolve();

    markDiscountDone(cart);
    return applyDiscount(code);
  }

  // 自分が送ったカート操作の印。お客様の「カートに追加」と取り違えないために付ける。
  const GIFT_REQUEST_HEADER = "X-Perk-Gift";

  function applyGiftOp(op) {
    if (op.line) {
      // 既にある行の数量を変える（0で削除）
      return fetch(getRootUrl() + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", [GIFT_REQUEST_HEADER]: "1" },
        body: JSON.stringify({ id: op.line.key, quantity: op.desired }),
      });
    }
    if (op.desired <= 0) return Promise.resolve();
    return fetch(getRootUrl() + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json", [GIFT_REQUEST_HEADER]: "1" },
      body: JSON.stringify({
        items: [{ id: op.variantId, quantity: op.desired, properties: { _item_type: "gift" } }],
      }),
    });
  }

  function syncGifts(items) {
    if (isCartPage() || giftSyncInFlight || perkGifts.length === 0) return Promise.resolve();
    const ops = planGiftOps(items);
    if (ops.length === 0) return Promise.resolve();

    giftSyncInFlight = true;
    // 自分の付与がおすすめセンター側の自動オープンを誘発しないようにする
    window.__perkGiftSyncUntil = Date.now() + 5000;

    return ops
      .reduce((chain, op) => chain.then(() => applyGiftOp(op)), Promise.resolve())
      .then(() => fetch(getRootUrl() + "cart.js", { cache: "no-store" }))
      .then((res) => res.json())
      .then((cart) => {
        updateFromItems(cart.items, cart.total_price);
        return syncDiscountState(cart);
      })
      .then(refreshCartUi)
      .catch(() => {})
      .then(() => {
        giftSyncInFlight = false;
      });
  }

  // 条件達成済みの施策はモーダルを開いた時点でアコーディオンを展開しておく
  function expandUnlockedBlocks() {
    overlay
      .querySelectorAll(
        "[data-perk-addon-block]:not(.perk-block--locked), [data-perk-gift-block]:not(.perk-gift--locked)"
      )
      .forEach((block) => {
        block.classList.add("perk-open");
        const toggle = block.querySelector("[data-perk-acc-toggle]");
        if (toggle) toggle.setAttribute("aria-expanded", "true");
      });
  }

  // --- モーダル開閉 ---
  const open = () => {
    overlay.hidden = false;
    expandUnlockedBlocks();
    // 一度開いたら注意喚起アニメーション（揺れ・点滅）を止める
    fab.classList.add("gift-fab--seen");
  };
  const close = () => {
    overlay.hidden = true;
    // 直接購入の案内は「ガード経由で開いた時だけ」の表示。閉じたらリセットし、
    // 通常のFABタップで開いた際に残らないようにする
    resetBuyNowNotice();
    // ×ボタンや背景タップで閉じた場合は「やめておく」を選んだものとして扱う
    resolveConfirm(false);
  };
  // アイコンと吹き出しのどちらからでも開ける
  wrap.addEventListener("click", (e) => {
    if (e.target instanceof Element && e.target.closest("[data-perk-open]")) open();
  });
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay || e.target.closest("[data-perk-close]")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeZoom();
      close();
    }
  });

  // --- 施策のアコーディオン開閉（クエストカードをタップで中身を下に展開） ---
  function toggleAccordion(toggle) {
    const blockEl = toggle.closest("[data-perk-addon-block], [data-perk-gift-block]");
    if (!blockEl) return;
    const open = blockEl.classList.toggle("perk-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      // 展開した中身が固定高さのシート内に収まるよう、下方向へスクロールして見せる
      setTimeout(() => {
        blockEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 50);
    }
  }
  overlay.addEventListener("click", (e) => {
    const chip = e.target.closest("[data-perk-gift-variant]");
    if (chip) {
      const block = chip.closest("[data-perk-gift-block]");
      if (block) changeGiftVariant(block, chip.getAttribute("data-perk-gift-variant"));
      return;
    }
    const toggle = e.target.closest("[data-perk-acc-toggle]");
    if (toggle) toggleAccordion(toggle);
  });
  overlay.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const toggle = e.target.closest("[data-perk-acc-toggle]");
    if (toggle) {
      e.preventDefault();
      toggleAccordion(toggle);
    }
  });

  // --- 画像の拡大表示（ライトボックス） ---
  const zoomOverlay = document.querySelector("[data-perk-zoom-overlay]");
  const zoomImage = document.querySelector("[data-perk-zoom-image]");
  function closeZoom() {
    if (zoomOverlay) zoomOverlay.hidden = true;
  }
  overlay.addEventListener("click", (e) => {
    const zoomBtn = e.target.closest("[data-perk-zoom]");
    if (!zoomBtn || !zoomOverlay || !zoomImage) return;
    zoomImage.src = zoomBtn.getAttribute("data-perk-zoom");
    zoomOverlay.hidden = false;
  });
  if (zoomOverlay) {
    zoomOverlay.addEventListener("click", closeZoom);
  }

  // --- 追加購入のステッパーとカート追加（施策ブロックごと） ---
  function blockSelectedTotal(block) {
    let total = 0;
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      total += selectedAddons[row.getAttribute("data-variant-id")] || 0;
    });
    return total;
  }

  function resetAddonSelection(block) {
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      delete selectedAddons[row.getAttribute("data-variant-id")];
      const qtyEl = row.querySelector("[data-perk-qty]");
      if (qtyEl) qtyEl.textContent = "0";
    });
  }

  function updateAddonAddButton(block) {
    const addBtn = block.querySelector("[data-perk-badge-add]");
    if (!addBtn) return;
    const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 1;
    addBtn.disabled = blockSelectedTotal(block) < 1 || countFor(block) < threshold;
  }

  overlay.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-perk-minus]");
    const plus = e.target.closest("[data-perk-plus]");
    if (!minus && !plus) return;
    const row = e.target.closest("[data-perk-badge-row]");
    const block = e.target.closest("[data-perk-addon-block]");
    if (!row || !block) return;
    const variantId = row.getAttribute("data-variant-id");
    const qtyEl = row.querySelector("[data-perk-qty]");
    const current = selectedAddons[variantId] || 0;
    const next = plus ? current + 1 : Math.max(0, current - 1);
    selectedAddons[variantId] = next;
    if (qtyEl) qtyEl.textContent = next;
    updateAddonAddButton(block);
  });

  overlay.addEventListener("click", (e) => {
    const addBtn = e.target.closest("[data-perk-badge-add]");
    if (!addBtn || addBtn.disabled) return;
    const block = addBtn.closest("[data-perk-addon-block]");
    if (!block) return;

    const items = [];
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      const variantId = row.getAttribute("data-variant-id");
      const qty = selectedAddons[variantId] || 0;
      if (qty > 0) {
        items.push({ id: variantId, quantity: qty, properties: { _item_type: "badge" } });
      }
    });
    if (items.length === 0) return;

    addBtn.disabled = true;
    const originalText = addBtn.textContent;
    addBtn.textContent = "追加中...";

    fetch((config.cartAddUrl || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => ({}))
            .then((err) => {
              throw new Error(err.description || "カートへの追加に失敗しました。");
            });
        }
        // カートページでは行の再描画が必要なためリロードする
        if (document.querySelector("cart-items")) {
          window.location.reload();
          return;
        }
        resetAddonSelection(block);
        addBtn.textContent = "追加しました！";
        setTimeout(() => {
          addBtn.textContent = originalText;
          updateAddonAddButton(block);
        }, 1500);
        // カートの中身だけでなく、ヘッダーのカート表示も追従させる
        refresh().then(refreshCartUi);
      })
      .catch((err) => {
        alert(err.message || "カートへの追加に失敗しました。時間をおいて再試行してください。");
        addBtn.textContent = originalText;
        updateAddonAddButton(block);
      });
  });

  // --- PageFly 等、テーマ標準の仕組みを通らないカート追加の検知 ---
  // おすすめセンター側とは別フラグで持ち、ファイル間の依存を作らない。
  const CART_ADD_PATTERN = /\/cart\/add(\.js)?(\?|$)/;
  // プレゼントの自動付与は自分で送っているので、お客様の操作として数えない
  function isOwnGiftRequest(init) {
    const headers = init && init.headers;
    if (!headers) return false;
    if (typeof headers.get === "function") return Boolean(headers.get(GIFT_REQUEST_HEADER));
    return Boolean(headers[GIFT_REQUEST_HEADER]);
  }
  const isCartAddUrl = (url) => Boolean(url) && CART_ADD_PATTERN.test(String(url).split("#")[0]);

  // 吹き出しを「カート追加の直後だけ」出すモード。
  // 常時表示モードでは何もしない（CSS側で出しっぱなしになっている）。
  function flashBubble() {
    if (config.bubbleDisplay !== "after_add") return;
    if (wrap.hidden) return;
    wrap.classList.add("is-bubble-shown");
    setTimeout(() => wrap.classList.remove("is-bubble-shown"), 6000);
  }

  let perkRefreshTimer = null;
  function scheduleRefresh() {
    if (perkRefreshTimer) clearTimeout(perkRefreshTimer);
    perkRefreshTimer = setTimeout(() => {
      perkRefreshTimer = null;
      refresh().then(handleAddedFeedback);
    }, 300);
  }

  function installNetworkHooks() {
    if (!config.pageflyDetect) return;
    if (window.__perkHooksInstalled) return;
    window.__perkHooksInstalled = true;

    if (typeof window.fetch === "function") {
      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const promise = originalFetch.apply(this, args);
        try {
          const input = args[0];
          const url = typeof input === "string" ? input : input && input.url;
          if (isCartAddUrl(url) && !isOwnGiftRequest(args[1])) {
            promise
              .then((res) => {
                if (res && res.ok) scheduleRefresh();
              })
              .catch(() => {});
          }
        } catch (e) {
          // URLが読めない形式でも本来の fetch は壊さない
        }
        return promise;
      };
    }

    const originalXhrOpen = XMLHttpRequest.prototype.open;
    const originalXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__perkUrl = url;
      return originalXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartAddUrl(this.__perkUrl)) {
        this.addEventListener("load", () => {
          if (this.status >= 200 && this.status < 300) scheduleRefresh();
        });
      }
      return originalXhrSend.apply(this, arguments);
    };
  }

  // --- 状態更新のトリガー ---
  document.addEventListener("DOMContentLoaded", () => {
    installNetworkHooks();
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      // カート全体を取り直してから判定するため、fetchフック経由と同じ道を通す。
      // ここで updateFromItems を直接呼ぶと、自動オープンの判定が走らない。
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh());
    }
    refresh();
  });

  // openWithNotice: 直接購入ガード（buy-now-guard）から呼ばれ、
  // モーダル上部の案内文（直接購入では特典が付かない旨）と
  // 「そのまま決済へ進む」「今後この案内を表示しない」を表示した状態で開く
  const buyNowNote = overlay.querySelector("[data-perk-buy-now-note]");
  const buyNowProceed = overlay.querySelector("[data-perk-buy-now-proceed]");
  const buyNowOptout = overlay.querySelector("[data-perk-buy-now-optout]");
  let buyNowProceedHandler = null;

  function resetBuyNowNotice() {
    if (buyNowNote) buyNowNote.hidden = true;
    if (buyNowProceed) buyNowProceed.hidden = true;
    if (buyNowOptout) buyNowOptout.hidden = true;
    buyNowProceedHandler = null;
  }

  if (buyNowProceed) {
    buyNowProceed.addEventListener("click", () => {
      if (buyNowProceedHandler) buyNowProceedHandler();
    });
  }
  if (buyNowOptout) {
    buyNowOptout.addEventListener("click", () => {
      // ブラウザに記憶し、以降は直接購入時の割り込み自体を行わない（buy-now-guardが参照）
      try {
        localStorage.setItem("perk-buy-now-optout", "1");
      } catch (e) {
        // localStorageが使えない環境ではこのページ内でのみ非表示
      }
      resetBuyNowNotice();
    });
  }

  // confirmRemoval: カートで特典が失われる操作（数量減・削除）をした際に、
  // ブラウザ標準の confirm() の代わりにモーダル内で「削除する／やめておく」を
  // 選んでもらう。cart-gift-sync.js から呼ばれ、選択結果をPromiseで返す。
  const confirmBlock = overlay.querySelector("[data-perk-confirm]");
  const confirmMessage = overlay.querySelector("[data-perk-confirm-message]");
  const confirmYes = overlay.querySelector("[data-perk-confirm-yes]");
  const confirmNo = overlay.querySelector("[data-perk-confirm-no]");
  let confirmResolve = null;

  function resolveConfirm(result) {
    if (confirmBlock) confirmBlock.hidden = true;
    if (confirmResolve) {
      const resolve = confirmResolve;
      confirmResolve = null;
      resolve(result);
    }
  }
  if (confirmYes) {
    confirmYes.addEventListener("click", () => {
      resolveConfirm(true);
      close();
    });
  }
  if (confirmNo) {
    confirmNo.addEventListener("click", () => {
      resolveConfirm(false);
      close();
    });
  }

  window.PerkFab = {
    refresh,
    open,
    openWithNotice(onProceed) {
      if (buyNowNote) buyNowNote.hidden = false;
      buyNowProceedHandler = typeof onProceed === "function" ? onProceed : null;
      if (buyNowProceed) buyNowProceed.hidden = buyNowProceedHandler === null;
      if (buyNowOptout) buyNowOptout.hidden = false;
      open();
    },
    confirmRemoval(message) {
      if (!confirmBlock || !confirmMessage) return Promise.resolve(true);
      confirmMessage.textContent = message;
      confirmBlock.hidden = false;
      open();
      return new Promise((resolve) => {
        // モーダルを閉じるボタン／背景タップでキャンセル扱いにする
        confirmResolve = resolve;
      });
    },
  };
})();
